import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

export const ACCOUNT_OPENING_QUOTA = 'integration.accountOpening.value'

export const useAccountOpeningQuota = (): { enabled: boolean; isLoading: boolean } => {
  const { hasQuota, quotaSuccess, isFetching } = useZocksQuota()
  return { enabled: hasQuota(ACCOUNT_OPENING_QUOTA), isLoading: !quotaSuccess && isFetching }
}
